import { handleApiCall } from "../api";

export const createAttributes = (createPayload) => handleApiCall("post", "attributes", createPayload);
 
export const getAttributes = () => handleApiCall("get", "attributes");

export const getAttributesById = (id) => handleApiCall("get", `attributes/${id}`);

export const removeAttribute = (id) => handleApiCall("delete", `attributes/${id}`);

export const updateAttributes = (id, updatePayload) => handleApiCall("patch", `attributes/${id}`,updatePayload)

